(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~transfer"],{

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(6);

// CONCATENATED MODULE: ./src/components/transfer/box.jsx

var Box = {
  name: 'Box',
  props: {
    dataSource: utils["d" /* vueTypes */].any,
    targetKeys: utils["d" /* vueTypes */].array,
    titles: utils["d" /* vueTypes */].array,
    boxStyle: utils["d" /* vueTypes */].any,
    type: utils["d" /* vueTypes */].string,
    change: utils["d" /* vueTypes */].func
  },
  methods: {},
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("div", {
      "class": 'meg-transfer-box',
      style: this.boxStyle
    }, [h("div", {
      "class": 'meg-transfer-box-header'
    }, [this.titles[this.type === "add" ? 0 : 1]]), h("div", {
      "class": 'meg-transfer-box-content'
    }, [this.dataSource.map(function (item) {
      var isIncludeKey = _this.targetKeys.includes(item.key);

      return (isIncludeKey && _this.type === "del" || !isIncludeKey && _this.type === "add") && h("div", {
        key: item.key,
        "class": 'meg-transfer-box-content-item',
        on: {
          "click": function click() {
            return _this.change(item.key, _this.type);
          }
        }
      }, [item.name]);
    })])]);
  }
};
/* harmony default export */ var box = (Box);
// CONCATENATED MODULE: ./src/components/transfer/index.jsx


// 样式文件
// import './style/index.scss';


var MegTransfer = {
  name: 'MegTransfer',
  model: {
    prop: "target-keys",
    event: "change"
  },
  props: {
    dataSource: utils["d" /* vueTypes */].any,
    targetKeys: utils["d" /* vueTypes */].array.def([]),
    titles: utils["d" /* vueTypes */].array.def(['', '']),
    boxStyle: utils["d" /* vueTypes */].any
  },
  methods: {
    change: function change(key, type) {
      if (type === 'del') {
        this.targetKeys.splice(this.targetKeys.indexOf(key), 1);
      } else {
        this.targetKeys.push(key);
      }

      this.$emit('change', this.targetKeys);
    }
  },
  render: function render() {
    var h = arguments[0];
    var props = {
      props: this.$props
    };
    return h("div", {
      "class": 'meg-transfer'
    }, [h(box, babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        type: "add",
        change: this.change
      }
    }, props])), h("div", {
      "class": 'meg-transfer-icon'
    }, [h("meg-icon", {
      attrs: {
        name: "megui-transfer"
      }
    })]), h(box, babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        type: "del",
        change: this.change
      }
    }, props]))]);
  }
};

MegTransfer.install = function (Vue) {
  Vue.component(MegTransfer.name, MegTransfer);
};

/* harmony default export */ var transfer = __webpack_exports__["default"] = (MegTransfer);

/***/ })

}]);